var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addForm" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addForm,
            "label-width": "150px",
            rules: _vm.formRole,
          },
        },
        [
          _vm._l(_vm.addForm.formList, function (item, index) {
            return _c(
              "el-row",
              { key: index, staticClass: "addFormItem" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "评分项名称：",
                      prop: "formList." + index + ".scoringName",
                      rules: _vm.formRole.scoringName,
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "input", placeholder: "请输入评分项名称" },
                      model: {
                        value: item.scoringName,
                        callback: function ($$v) {
                          _vm.$set(item, "scoringName", $$v)
                        },
                        expression: "item.scoringName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "分数：",
                              prop: "formList." + index + ".scoringScore",
                              rules: _vm.formRole.scoringScore,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "input",
                                placeholder: "请输入分数",
                              },
                              model: {
                                value: item.scoringScore,
                                callback: function ($$v) {
                                  _vm.$set(item, "scoringScore", $$v)
                                },
                                expression: "item.scoringScore",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "hintTex", attrs: { span: 8 } },
                      [
                        _vm._v(
                          "\n          *所有评分项相加总分为100分\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "排序：",
                              prop: "formList." + index + ".scoringSort",
                              rules: _vm.formRole.scoringSort,
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "input",
                                placeholder: "请输入排序",
                              },
                              model: {
                                value: item.scoringSort,
                                callback: function ($$v) {
                                  _vm.$set(item, "scoringSort", $$v)
                                },
                                expression: "item.scoringSort",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { staticClass: "hintTex", attrs: { span: 8 } },
                      [_vm._v("*数字越小排名越靠前")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "评分内容：" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        placeholder: "请输入评分内容",
                        maxlength: "150",
                        "show-word-limit": "",
                      },
                      model: {
                        value: item.scoringContent,
                        callback: function ($$v) {
                          _vm.$set(item, "scoringContent", $$v)
                        },
                        expression: "item.scoringContent",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "评分要素：" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        placeholder: "请输入评分要素",
                        maxlength: "150",
                        "show-word-limit": "",
                      },
                      model: {
                        value: item.scoringElement,
                        callback: function ($$v) {
                          _vm.$set(item, "scoringElement", $$v)
                        },
                        expression: "item.scoringElement",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { staticClass: "addWorksItem" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary", plain: "" },
                        on: { click: _vm.addItem },
                      },
                      [_vm._v("新增评分项")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "danger", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(index)
                          },
                        },
                      },
                      [_vm._v("删除评分项")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "submitBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("addForm")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.isBack },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }